import { useLocation } from "react-router-dom";
import Footer from "../sections/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import FooterTop from "../sections/FooterTop/FooterTop";
import { Outlet } from "react-router-dom";

export default function Layout() {
  const location = useLocation();
  const showFooterTopRoutes = ["/mentors", "/authors"];
  const shouldHideFooterTop = showFooterTopRoutes.includes(location.pathname);

  return (
    <>
      <Navbar />
      <Outlet />
      {/* {shouldHideFooterTop && <FooterTop />} */}
      <Footer />
    </>
  );
}
